import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthProvider";
import LoadingScreen from "../Componentes/LoadingScreen";
import { VerifyPermission } from "../Funcoes/VerifyPermission";

const PrivateRoute = ({ requiredPermission = null }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <LoadingScreen />;
    }

    if (!user) {
        console.log("Usuário não autenticado, redirecionando para /login");
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (user?.DEVE_TROCAR_SENHA && location.pathname !== "/trocar-senha") {
        return <Navigate to="/trocar-senha" replace />;
    }

    if (requiredPermission) {

        const hasPermission = VerifyPermission(user, requiredPermission);

        if (!hasPermission) {

            return <Navigate to="/modules" replace />;

        }

    }

    return <Outlet />;

};

export default PrivateRoute;
